/**
 * version-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Todd L Smith <tsmith@safetyweb.org>
 */

import { MessageTag } from "../message-tag";
import { Message } from "./message";
import { ReplyVerifyingMessage } from "./reply-message";
import { VersionResponse } from "./version-response";

/**
 * A client begins a conversion with a server by sending a {@link
 * VersionRequestMessage} that includes its preferred protocol version.
 * The server responds with a {@link VersionInfoMessage}.
 */
export class VersionRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_VERSION;
	public static tag : MessageTag = MessageTag.REQ_VERSION;

  public expectsReply () : boolean
  {
    return true;
  }

  public verifyReply (reply : Message) : boolean
  {
    return (
      Message.isA(reply, MessageTag.RSP_VERSION)
        && (reply as VersionResponse).ok);
  }

  /**
   * Construct a new {@link VersionRequestMessage}.
   *
   * @param protocolVersion
   *        The server-client message protocol version.
   */
  constructor (public version : number)
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/general/version-request.ts